import type { GraphQLFormattedError } from 'graphql';

const parseValidationError = (
  msg: string | GraphQLFormattedError,
): { field: string; message: string } | null => {
  const message = typeof msg === 'string' ? msg : msg.message;
  const match = message.match(/^VALIDATION: \[(.+)\] (.+)$/);

  const field = match?.[1];
  const parsedMessage = match?.[2];

  if (field == null || parsedMessage == null) {
    return null;
  }

  return { field, message: parsedMessage };
};

export default parseValidationError;
